import padlock from "./padlock.svg";
import "./index.css";

export function UnpaymentPage() {
  const link_url = "https://t.me/ndidkivska";
  return (
    <>
      <div className="unpaymentPageSection">
        <div className="unpaymentPageConteiner">
          <img src={padlock} alt=""/>
          <h4 className="textUnpaymentPageConteiner">
            Упс, не пугайтесь. Напишите менеджеру и он откроет вам доступ к
            обучению!
          </h4>
          <a href={link_url}>
            <div className="unpayment-button">Написать менеджеру</div>
          </a>
        </div>
      </div>
    </>
  );
}
